// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-header {
  background-color: var(--surface-raised);
  box-shadow: var(--shadow-soft);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px !important;
}

.brand {
  display: flex;
  align-items: center;
}

.brand-logo {
  height: 48px;
  width: auto;
  display: block;
}

.main-nav {
  display: flex;
  gap: 28px;
  align-items: center;
}

.main-nav a,
.main-nav a:visited,
.nav-dropdown-toggle {
  /* \`font\` is a shorthand and resets font-weight, so it has to come before
     the weight below — the other way round it silently wipes it out and the
     whole nav, Donate pill included, falls back to the body's 400. It's here
     at all so the <button> toggle picks up the page font. */
  font: inherit;
  font-weight: 600;
  color: var(--text-primary);
  padding: 6px 4px;
  border-bottom: 2px solid transparent;
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  cursor: pointer;
}

.main-nav a:hover,
.nav-dropdown-toggle:hover {
  text-decoration: none;
  color: var(--text-accent);
}

.main-nav a.active,
.nav-dropdown-menu a.active {
  border-bottom-color: var(--text-accent);
}

.nav-dropdown {
  position: relative;
}

.nav-dropdown-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.nav-dropdown-toggle::after {
  content: "▾";
  font-size: 0.8rem;
}

.nav-dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  left: 0;
  min-width: 200px;
  display: none;
  flex-direction: column;
  gap: 8px;
  background-color: var(--surface-raised);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  box-shadow: var(--shadow-soft);
  padding: 12px;
  z-index: 10;
}

.nav-dropdown.open .nav-dropdown-menu {
  display: flex;
}

.nav-dropdown-menu a,
.nav-dropdown-menu a:visited {
  color: var(--text-primary);
  padding: 8px 18px;
  border-bottom: none;
  font-weight: 500;
}

.nav-dropdown-menu a:hover {
  background-color: var(--surface-sunken);
  text-decoration: none;
}

.main-nav a.donate-link,
.main-nav a.donate-link:visited {
  background-color: var(--interactive-default);
  color: var(--interactive-label);
  padding: 8px 20px;
  border-radius: 999px;
  border: 2px solid var(--interactive-edge);
}

.main-nav a.donate-link:hover {
  background-color: var(--interactive-hover);
  color: var(--interactive-label);
}

.main-nav a.donate-link.active {
  background-color: var(--interactive-hover);
}

/* Placeholder until the app launches: looks like a nav item but isn't
   clickable. Text stays full ink (7.02) so it's still readable. */
.nav-lilypad {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: var(--text-primary);
  padding: 6px 4px;
  cursor: default;
}

/* Coral fill with the ink-deep label (7.83), as on the site's buttons. */
.nav-coming-soon {
  background-color: var(--interactive-default);
  color: var(--interactive-label);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 3px 8px;
  border-radius: 999px;
  white-space: nowrap;
}

.nav-toggle {
  display: none;
}

/* Narrow screens: the full nav no longer fits beside the logo (it overflowed
   the page between ~600 and ~960px), so it collapses behind a menu button
   and opens as a full-width panel under the header. */
@media (max-width: 980px) {
  .nav-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    border: none;
    border-radius: var(--radius-md);
    background: transparent;
    color: var(--text-primary);
    cursor: pointer;
  }

  .nav-toggle:hover {
    background-color: var(--surface-sunken);
  }

  /* Positioned against the sticky .site-header, so it spans the full width. */
  .main-nav {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    background-color: var(--surface-raised);
    border-top: 1px solid var(--border-subtle);
    box-shadow: var(--shadow-soft);
    padding: 8px 24px 20px;
    max-height: calc(100vh - 76px);
    overflow-y: auto;
  }

  .main-nav.open {
    display: flex;
  }

  /* Hairline dividers between rows. Doubled class to beat the base
     \`.main-nav a { border-top: none }\`; the Donate pill's own border still
     wins (its selector is more specific). */
  .main-nav.main-nav > * + * {
    border-top: 1px solid var(--border-subtle);
  }

  .main-nav > a,
  .main-nav > a:visited,
  .nav-dropdown-toggle,
  .nav-lilypad {
    display: flex;
    width: 100%;
    padding: 14px 4px;
    border-bottom: none;
    text-align: left;
  }

  .nav-dropdown-toggle {
    justify-content: space-between;
  }

  .nav-dropdown-toggle::after {
    display: inline-block;
    transition: transform 0.15s ease;
  }

  .nav-dropdown.open .nav-dropdown-toggle::after {
    transform: rotate(180deg);
  }

  /* Rows use dividers, so the active page is shown by color instead of the
     desktop underline. */
  .main-nav a.active,
  .nav-dropdown-menu a.active {
    border-bottom-color: transparent;
    color: var(--text-accent);
  }

  /* Dropdowns expand in place instead of floating. */
  .nav-dropdown-menu {
    position: static;
    min-width: 0;
    gap: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0 0 10px 12px;
  }

  .nav-dropdown-menu a,
  .nav-dropdown-menu a:visited {
    padding: 10px 12px;
    border-radius: var(--radius-md);
  }

  .main-nav a.donate-link,
  .main-nav a.donate-link:visited {
    justify-content: center;
    margin-top: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE;;;4DAG0D;EAC1D,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uCAAuC;EACvC,sCAAsC;EACtC,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;;EAEE,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;kEACkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;;sDAEsD;AACtD;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,uBAAuB;IACvB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,uCAAuC;EACzC;;EAEA,4EAA4E;EAC5E;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;IACN,uCAAuC;IACvC,0CAA0C;IAC1C,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;;4CAE0C;EAC1C;IACE,0CAA0C;EAC5C;;EAEA;;;;IAIE,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;yBACuB;EACvB;;IAEE,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA,mDAAmD;EACnD;IACE,gBAAgB;IAChB,YAAY;IACZ,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;;IAEE,uBAAuB;IACvB,gBAAgB;EAClB;AACF","sourcesContent":[".site-header {\n  background-color: var(--surface-raised);\n  box-shadow: var(--shadow-soft);\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.nav-inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 24px !important;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n}\n\n.brand-logo {\n  height: 48px;\n  width: auto;\n  display: block;\n}\n\n.main-nav {\n  display: flex;\n  gap: 28px;\n  align-items: center;\n}\n\n.main-nav a,\n.main-nav a:visited,\n.nav-dropdown-toggle {\n  /* `font` is a shorthand and resets font-weight, so it has to come before\n     the weight below — the other way round it silently wipes it out and the\n     whole nav, Donate pill included, falls back to the body's 400. It's here\n     at all so the <button> toggle picks up the page font. */\n  font: inherit;\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 6px 4px;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  cursor: pointer;\n}\n\n.main-nav a:hover,\n.nav-dropdown-toggle:hover {\n  text-decoration: none;\n  color: var(--text-accent);\n}\n\n.main-nav a.active,\n.nav-dropdown-menu a.active {\n  border-bottom-color: var(--text-accent);\n}\n\n.nav-dropdown {\n  position: relative;\n}\n\n.nav-dropdown-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.nav-dropdown-toggle::after {\n  content: \"▾\";\n  font-size: 0.8rem;\n}\n\n.nav-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 0;\n  min-width: 200px;\n  display: none;\n  flex-direction: column;\n  gap: 8px;\n  background-color: var(--surface-raised);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  box-shadow: var(--shadow-soft);\n  padding: 12px;\n  z-index: 10;\n}\n\n.nav-dropdown.open .nav-dropdown-menu {\n  display: flex;\n}\n\n.nav-dropdown-menu a,\n.nav-dropdown-menu a:visited {\n  color: var(--text-primary);\n  padding: 8px 18px;\n  border-bottom: none;\n  font-weight: 500;\n}\n\n.nav-dropdown-menu a:hover {\n  background-color: var(--surface-sunken);\n  text-decoration: none;\n}\n\n.main-nav a.donate-link,\n.main-nav a.donate-link:visited {\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n  padding: 8px 20px;\n  border-radius: 999px;\n  border: 2px solid var(--interactive-edge);\n}\n\n.main-nav a.donate-link:hover {\n  background-color: var(--interactive-hover);\n  color: var(--interactive-label);\n}\n\n.main-nav a.donate-link.active {\n  background-color: var(--interactive-hover);\n}\n\n/* Placeholder until the app launches: looks like a nav item but isn't\n   clickable. Text stays full ink (7.02) so it's still readable. */\n.nav-lilypad {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 6px 4px;\n  cursor: default;\n}\n\n/* Coral fill with the ink-deep label (7.83), as on the site's buttons. */\n.nav-coming-soon {\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  padding: 3px 8px;\n  border-radius: 999px;\n  white-space: nowrap;\n}\n\n.nav-toggle {\n  display: none;\n}\n\n/* Narrow screens: the full nav no longer fits beside the logo (it overflowed\n   the page between ~600 and ~960px), so it collapses behind a menu button\n   and opens as a full-width panel under the header. */\n@media (max-width: 980px) {\n  .nav-toggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    padding: 0;\n    border: none;\n    border-radius: var(--radius-md);\n    background: transparent;\n    color: var(--text-primary);\n    cursor: pointer;\n  }\n\n  .nav-toggle:hover {\n    background-color: var(--surface-sunken);\n  }\n\n  /* Positioned against the sticky .site-header, so it spans the full width. */\n  .main-nav {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n    background-color: var(--surface-raised);\n    border-top: 1px solid var(--border-subtle);\n    box-shadow: var(--shadow-soft);\n    padding: 8px 24px 20px;\n    max-height: calc(100vh - 76px);\n    overflow-y: auto;\n  }\n\n  .main-nav.open {\n    display: flex;\n  }\n\n  /* Hairline dividers between rows. Doubled class to beat the base\n     `.main-nav a { border-top: none }`; the Donate pill's own border still\n     wins (its selector is more specific). */\n  .main-nav.main-nav > * + * {\n    border-top: 1px solid var(--border-subtle);\n  }\n\n  .main-nav > a,\n  .main-nav > a:visited,\n  .nav-dropdown-toggle,\n  .nav-lilypad {\n    display: flex;\n    width: 100%;\n    padding: 14px 4px;\n    border-bottom: none;\n    text-align: left;\n  }\n\n  .nav-dropdown-toggle {\n    justify-content: space-between;\n  }\n\n  .nav-dropdown-toggle::after {\n    display: inline-block;\n    transition: transform 0.15s ease;\n  }\n\n  .nav-dropdown.open .nav-dropdown-toggle::after {\n    transform: rotate(180deg);\n  }\n\n  /* Rows use dividers, so the active page is shown by color instead of the\n     desktop underline. */\n  .main-nav a.active,\n  .nav-dropdown-menu a.active {\n    border-bottom-color: transparent;\n    color: var(--text-accent);\n  }\n\n  /* Dropdowns expand in place instead of floating. */\n  .nav-dropdown-menu {\n    position: static;\n    min-width: 0;\n    gap: 0;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0 0 10px 12px;\n  }\n\n  .nav-dropdown-menu a,\n  .nav-dropdown-menu a:visited {\n    padding: 10px 12px;\n    border-radius: var(--radius-md);\n  }\n\n  .main-nav a.donate-link,\n  .main-nav a.donate-link:visited {\n    justify-content: center;\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
